import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import { useIntl } from 'react-intl'
import {requestPassword} from '../redux/AuthCRUD'

const initialValues = {
  email: '',
}


export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [error, setError] = useState(undefined)
  const intl = useIntl()
  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(intl.formatMessage({ id: 'AUTH.VALIDATION.WRONG_EMAIL' }))
      .min(3, intl.formatMessage({ id: 'AUTH.VALIDATION.MIN_LENGTH_3' }))
      .max(50, intl.formatMessage({ id: 'AUTH.VALIDATION.MAX_LENGTH_50' }))
      .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_EMAIL' })),
  })
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestPassword(values.email)
          .then(({data: {result}}) => {
            setHasErrors(false)
            setLoading(false)
          })
          .catch((error) => {
            console.log("error:", error.response.data.text)
            setError(error.response.data.text)
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text mb-10'>
          {/* begin::Title */}
          <h1 className='text mb-3 title-login-form'>{intl.formatMessage({ id: 'AUTH.GENERAL.FORGOT_BUTTON' })}</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>{intl.formatMessage({ id: 'AUTH.GENERAL.FORGOT_TITLE_INFO' })}</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && error && (
          <div className='mb-lg-8 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              {error}
            </div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>{intl.formatMessage({ id: 'AUTH.GENERAL.FORGOT_MESSAGE' })}</div>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container mb-3'>
              <div className='fv-help-block'>
                <span className='error-alert' role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
          <input
            id='input-login'
            type='email'
            placeholder={intl.formatMessage({ id: 'AUTH.INPUT.EMAIL' })}
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-between pb-lg-0'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-lg  fw-bolder me-4'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span style={{color:'white'}} className='indicator-label'>{intl.formatMessage({ id: 'AUTH.GENERAL.SUBMIT_BUTTON' })}</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block', color:'white' }}>
                {intl.formatMessage({ id: 'POPLEADS.PLEASE_WAIT' })}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          
            
              <Link  
              to='/auth/login'
              className='forgot-password-text'
              >{intl.formatMessage({ id: 'AUTH.GENERAL.CANCEL_BUTTON' })} </Link>
           
          
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
